module.exports = __webpack_public_path__ + "img/symbol_3.493d41b5.png";